module.exports = __webpack_public_path__ + "static/media/dungeon_floor_se.e756d2f2.png";